import React, { useState } from 'react'
import { webSocketWorkerEvent } from '../../../services/index.js'
import TradeRemainingOptions from '../classes/TradeReamainingOptions'
import TradeEnhancedReverseOption from '../classes/TradeEnhancedReverseOption'
import TradeSpot from '../classes/TradeSpot'
import TradeVanilla from '../classes/TradeVanilla'
import TradeDigitalOption from '../classes/TradeDigitalOption'
import TradeDigitalKnockInKnockOut from '../classes/TradeDigitalKnockInKnockOut'
import TradeDigitalDoubles from '../classes/TradeDigitalDoubles'
import TradeDoubleNoTouchOption from '../classes/TradeDoubleNoTouchOption'
import TradeMoreDoubles from '../classes/TradeMoreDoubles'
import TradeTouchOptions from '../classes/TradeTouchOptions.js'
import RemainingOptionsTrade from '../components/RemainingOptions/RemainingOptionsTrade.js'
import TouchOptionsTrade from '../components/TouchOptions/TouchOptionsTrade.js'
import MoreDoublesTrade from '../components/MoreDoubles/MoreDoublesTrade.js'
import DoubleNoTouchOptionTrade from '../components/DoubleNoTouchOption/DoubleNoTouchOptionTrade.js'
import DigitalKnockInKnockOutTrade from '../components/DigitalKnockInKnockOut/DigitalKnockInKnockOutTrade.js'
import DigitalOptionTrade from '../components/DigitalOption/DigitalOptionTrade.js'
import DigitalDoublesTrade from '../components/DigitalDoubles/DigitalDoublesTrade.js'
import { ACTION, DATE_FORMAT, DEAL_GROUP, TRADE_BLOTTER_STATUS } from '../../../utils/constants.js'
import dayjs from 'dayjs'
import TradeSwap from '../classes/TradeSwap.js'
import TradeForward from '../classes/TradeForward.js'
import TradeNdf from '../classes/TradeNdf.js'
import TradeForm from '../classes/TradeForm.js'
import EnhancedReverseOptionTrade from '../components/EnhancedReverseOption/EnhancedReverseOptionTrade.js'

const useTradeSetting = ({
  data,
  action,
  form,
  tradeTypesGroup,
  setForm,
  currencyData,
  currencyInitial,
  currencyNormalize,
  barrierDirectionData,
  tradingAccountPrimeBrokerNormalize,
  errors,
  setErrors
}) => {
  const initialStateSwapOption = () => {
    if (form.fixing_date && form.far_fixing_date && form.fixing_source) {
      return true
    }
    return false
  }

  const [swapOption, setSwapOption] = useState(initialStateSwapOption())

  const resetForm = tradeType => {
    const newForm = new TradeForm({ type: tradeType, direction: form.direction })
    if (swapOption) {
      setSwapOption(false)
    }
    setErrors({})
    setForm(newForm)
  }

  const handelFocusCurrencyPair = () => {
    setErrors({ ...errors, currency_pair: '' })
  }

  const handelSwapDeal = (counterparty = form.counterparty) => {
    if (form.currency_pair.length >= 3) {
      const counterpartyPrimeBroker =
        tradingAccountPrimeBrokerNormalize.data.trading_account_prime_broker[counterparty]
      const baseCurrency = form.currency_pair.substring(0, 3)
      const counterCurrency = form.currency_pair.substring(3, 6)
      const baseCurrencyInfo = currencyNormalize.data[baseCurrency]
      const counterCurrencyInfo = currencyNormalize.data[counterCurrency]
      if (
        (baseCurrencyInfo?.is_ndf || counterCurrencyInfo?.is_ndf) &&
        counterpartyPrimeBroker?.prime_broker === 'HSBC'
      ) {
        setErrors({ ...errors, currency_pair: `cannot book NDF Swaps for HSBC` })
        setSwapOption(false)
        return true
      }
      if (
        (baseCurrencyInfo?.is_ndf || counterCurrencyInfo?.is_ndf) &&
        counterpartyPrimeBroker?.prime_broker !== 'HSBC' &&
        errors.currency_pair === 'cannot book NDF Swaps for HSBC'
      ) {
        const copyErrors = { ...errors }
        delete copyErrors.currency_pair
        setErrors(copyErrors)
      } else if (form.currency_pair.length >= 3 && baseCurrencyInfo?.is_ndf) {
        setSwapOption(true)
      } else if (form.currency_pair.length === 6 && counterCurrencyInfo?.is_ndf) {
        setSwapOption(true)
      } else {
        setSwapOption(false)
      }
    } else if (swapOption) {
      setSwapOption(false)
    }
  }

  const handelBlurCurrencyPair = () => {
    if (form?.trade_type?.deal_type_group === DEAL_GROUP.SWAP) {
      const flag = handelSwapDeal()
      if (flag === true) {
        return
      }
    }
    if (form.currency_pair !== '') {
      if (form.currency_pair.length !== 6) {
        setErrors({ ...errors, currency_pair: 'currency too short' })
        return
      }
      const baseCurrency = form.currency_pair.substring(0, 3)
      const counterCurrency = form.currency_pair.substring(3, 6)
      const errorBaseCurrency = currencyNormalize.data[baseCurrency]
      const errorCounterCurrency = currencyNormalize.data[counterCurrency]

      if (errorBaseCurrency && errorCounterCurrency && errorBaseCurrency === errorCounterCurrency) {
        setErrors({ ...errors, currency_pair: "currencies can't be the same" })
        return
      }

      if (!errorBaseCurrency && !errorCounterCurrency) {
        setErrors({ ...errors, currency_pair: 'currencies not found' })
        return
      }

      if (!errorBaseCurrency) {
        setErrors({ ...errors, currency_pair: 'base currency not found' })
        return
      }

      if (!errorCounterCurrency) {
        setErrors({ ...errors, currency_pair: 'counter currency not found' })
        return
      }
    }
  }

  const disabled = () => {
    if (errors.currency_pair) {
      return true
    }
    const disabledField = (formKey, formValue) => {
      if (formKey === 'premium' && +formValue >= 0) {
        return false
      }
      if (
        [
          'quantity',
          'price',
          'strike',
          'lower_barrier',
          'upper_barrier',
          'payout_amount',
          'barrier',
          'spot_ref',
          'far_price',
          'far_leg_quantity'
        ].includes(formKey) &&
        +formValue === 0
      ) {
        return true
      }
      if (['note', 'bdr', 'barrier_direction'].includes(formKey) && formValue === '') {
        return false
      }

      if (['trader_name'].includes(formKey) && formValue === '') {
        if (!['Spot', 'Swap', 'Forward', 'NDF'].includes(form.trade_type?.deal_type_group)) {
          return false
        } else {
          return true
        }
      }
      if (['string', 'number'].includes(typeof formValue)) {
        return !formValue
      } else if (typeof formValue === 'object') {
        return !formValue.name
      }
    }

    let trade
    if (!('data' in tradeTypesGroup)) {
      return true
    }

    switch (form?.trade_type?.deal_type_group) {
      case DEAL_GROUP.SPOT:
        trade = new TradeSpot(form, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.VANILLA_OPTION:
        trade = new TradeVanilla(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.DIGITAL_OPTION:
        trade = new TradeDigitalOption(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.DIGITAL_KNOCK_IN_KNOCK_OUTS:
        trade = new TradeDigitalKnockInKnockOut(
          form,
          currencyNormalize,
          tradingAccountPrimeBrokerNormalize
        )
        break
      case DEAL_GROUP.DOUBLE_NO_TOUCH_OPTION:
        trade = new TradeDoubleNoTouchOption(form, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.DIGITAL_DOUBLES:
        trade = new TradeDigitalDoubles(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.MORE_DOUBLES:
        trade = new TradeMoreDoubles(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.TOUCH_OPTIONS:
        trade = new TradeTouchOptions(form, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.ENHANCED_REVERSE_OPTIONS:
        trade = new TradeEnhancedReverseOption(
          form,
          currencyNormalize,
          tradingAccountPrimeBrokerNormalize
        )
        break
      case DEAL_GROUP.REMAINING_OPTIONS:
        trade = new TradeRemainingOptions(
          form,
          currencyNormalize,
          tradingAccountPrimeBrokerNormalize
        )
        break
      case DEAL_GROUP.SWAP:
        trade = new TradeSwap(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.FORWARD:
        trade = new TradeForward(form, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.NDF:
        trade = new TradeNdf(form, tradingAccountPrimeBrokerNormalize)
        break
      default:
        return true
    }

    return Object.entries(trade).some(([key, value]) => disabledField(key, value))
  }

  const submitForm = () => {
    let trade
    switch (form?.trade_type?.deal_type_group) {
      case DEAL_GROUP.SPOT:
        trade = new TradeSpot(form, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.VANILLA_OPTION:
        trade = new TradeVanilla(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.DIGITAL_OPTION:
        trade = new TradeDigitalOption(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.DIGITAL_KNOCK_IN_KNOCK_OUTS:
        trade = new TradeDigitalKnockInKnockOut(
          form,
          currencyNormalize,
          tradingAccountPrimeBrokerNormalize
        )
        break
      case DEAL_GROUP.DIGITAL_DOUBLES:
        trade = new TradeDigitalDoubles(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.DOUBLE_NO_TOUCH_OPTION:
        trade = new TradeDoubleNoTouchOption(form, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.MORE_DOUBLES:
        trade = new TradeMoreDoubles(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.TOUCH_OPTIONS:
        trade = new TradeTouchOptions(form, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.ENHANCED_REVERSE_OPTIONS:
        trade = new TradeEnhancedReverseOption(
          form,
          currencyNormalize,
          tradingAccountPrimeBrokerNormalize
        )
        break
      case DEAL_GROUP.REMAINING_OPTIONS:
        trade = new TradeRemainingOptions(
          form,
          currencyNormalize,
          tradingAccountPrimeBrokerNormalize
        )
        break
      case DEAL_GROUP.SWAP:
        trade = new TradeSwap(form, currencyNormalize, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.FORWARD:
        trade = new TradeForward(form, tradingAccountPrimeBrokerNormalize)
        break
      case DEAL_GROUP.NDF:
        trade = new TradeNdf(form, tradingAccountPrimeBrokerNormalize)
        break
      default:
        break
    }

    const validationImprove = validateWindowsStartAndWindowsEnd()
    if (validationImprove === false || errors.currency_pair) {
      return
    }
    if (action === ACTION.CREATE) {
      webSocketWorkerEvent.sendEvent({
        type: 'create_trade',
        data: trade
      })
      setForm({ ...form, trade_date: dayjs().format(DATE_FORMAT.REGULAR_DATE_TIME) })
    } else if (action === ACTION.UPDATE) {
      if (
        !trade.isEqual({
          trade: { ...data.data },
          currencyNormalize,
          tradingAccountPrimeBrokerNormalize
        })
      ) {
        trade.id = Number(data.data.id)
        delete trade.trade_date
        delete trade.trade_type
        delete trade.trade_origin
        webSocketWorkerEvent.sendEvent({
          type: 'update_trade',
          data: trade
        })
      }
    }
  }

  const handelFormChange = (event, element) => {
    const copyForm = { ...form }
    let { name, value, checked } = event.target

    if (
      [
        'barrier_direction',
        'counterparty',
        'premium_currency',
        'option_payment_currency',
        'fixing_source',
        'trade_type',
        'payout_currency',
        'cut',
        'trader_name'
      ].includes(name)
    ) {
      if (name === 'trade_type') {
        return resetForm(element)
      }

      if (name === 'counterparty') {
        const counterparty = element.split(' ').slice(0, -1).join(' ')
        copyForm[name] = counterparty
        if (form.trader_name !== '') {
          copyForm.trader_name = ''
        }
        if (form?.trade_type?.deal_type_group === DEAL_GROUP.SWAP) {
          handelSwapDeal(counterparty)
        }
      } else {
        copyForm[name] = element
      }
    } else if (
      [
        'currency_pair',
        'side',
        'note',
        'trade_origin',
        'put_call',
        'option_exercise_style',
        'timing',
        'bdr'
      ].includes(name)
    ) {
      if (name === 'currency_pair') {
        if (value.length < 7) {
          copyForm[name] = value.toUpperCase()
        }
      } else {
        copyForm[name] = value
      }
    } else if (
      [
        'quantity',
        'price',
        'premium_amount',
        'strike',
        'lower_barrier',
        'upper_barrier',
        'payout_amount',
        'barrier',
        'spot_ref',
        'far_price',
        'far_leg_quantity'
      ].includes(name) &&
      ((!isNaN(value) && +value >= 0) ||
        value === '' ||
        (String(value).length > 1 &&
          String(value).endsWith('.') &&
          String(value).split('.').length < 3))
    ) {
      if (
        String(value).length > 1 &&
        String(value).endsWith('.') &&
        String(value).split('.').length < 3
      ) {
        copyForm[name] = value
      } else if (value === '') {
        copyForm[name] = value
      } else {
        copyForm[name] = String(value)
      }
    } else if (['is_structure', 'is_pba', 'is_conversion'].includes(name)) {
      copyForm[name] = checked
    }
    setForm(copyForm)
  }

  const checkPrimeBrokerIsRBS = () => {
    const tradingAccountPrimeBrokerForCounterparty =
      tradingAccountPrimeBrokerNormalize?.data?.trading_account_prime_broker[form.counterparty]
    if (
      form.counterparty &&
      tradingAccountPrimeBrokerForCounterparty &&
      tradingAccountPrimeBrokerForCounterparty.prime_broker === 'RBS'
    ) {
      return true
    } else {
      return false
    }
  }

  const getTradeTemplateGridRow = () => {
    if (['', 'Spot', 'NDF', 'Swap', 'Forward'].includes(form.trade_type.deal_type_group)) {
      return { gridTemplateColumns: 'repeat(2,1fr)' }
    } else {
      return { gridTemplateColumns: 'repeat(3,1fr)' }
    }
  }

  const disabledConversionCheckBox = () => {
    if (data.status === TRADE_BLOTTER_STATUS.CONVERSION && data.staging_status === null) {
      return true
    }
    return false
  }

  const disabledField = () => {
    const disabledFormField = {
      put_call: false,
      fixing_source: false,
      fixing_date: false,
      strike: false
    }

    const { trade_type, currency_pair } = form
    const dealGroup = trade_type?.deal_type_group

    const disableFixingIfNotNDF = () => {
      const baseCurrency = currency_pair?.substring(0, 3)
      const counterCurrency = currency_pair?.substring(3, 6)
      const baseInfo = currencyNormalize?.data?.[baseCurrency]
      const counterInfo = currencyNormalize?.data?.[counterCurrency]
      if (!baseInfo?.is_ndf && !counterInfo?.is_ndf) {
        disabledFormField.fixing_date = true
        disabledFormField.fixing_source = true
        if (form.fixing_source) {
          setForm({ ...form, fixing_source: '' })
        }
      }
    }

    const disableFixingDateIfNotNDF = () => {
      const baseCurrency = currency_pair?.substring(0, 3)
      const counterCurrency = currency_pair?.substring(3, 6)
      const baseInfo = currencyNormalize?.data?.[baseCurrency]
      const counterInfo = currencyNormalize?.data?.[counterCurrency]
      if (!baseInfo?.is_ndf && !counterInfo?.is_ndf) {
        disabledFormField.fixing_date = true
      }
    }

    switch (dealGroup) {
      case DEAL_GROUP.DOUBLE_NO_TOUCH_OPTION:
      case DEAL_GROUP.TOUCH_OPTIONS:
        Object.assign(disabledFormField, {
          fixing_date: true,
          fixing_source: true,
          strike: true,
          put_call: true
        })
        break
      case DEAL_GROUP.DIGITAL_OPTION:
      case DEAL_GROUP.DIGITAL_KNOCK_IN_KNOCK_OUTS:
      case DEAL_GROUP.DIGITAL_DOUBLES:
      case DEAL_GROUP.ENHANCED_REVERSE_OPTIONS:
        disableFixingDateIfNotNDF()
        break
      case DEAL_GROUP.VANILLA_OPTION:
      case DEAL_GROUP.MORE_DOUBLES:
      case DEAL_GROUP.REMAINING_OPTIONS:
        disableFixingIfNotNDF()
        break

      default:
        break
    }

    return disabledFormField
  }

  const handelDateChange = (name, value) => {
    const copyForm = { ...form }
    if (
      [
        'value_date',
        'premium_date',
        'settlement_date',
        'expiry',
        'fixing_date',
        'window_start',
        'window_end',
        'far_fixing_date',
        'far_value_date'
      ].includes(name)
    ) {
      copyForm[name] = value
    }
    setForm(copyForm)
  }

  const validateWindowsStartAndWindowsEnd = () => {
    if (form.window_start === '' && form.window_end === '') {
      return true
    }
    if (
      !(
        dayjs(form.window_start).isBefore(dayjs(form.window_end)) ||
        dayjs(form.window_start).isSame(dayjs(form.window_end))
      )
    ) {
      setErrors({ ...errors, window_start: "date can't be after window end" })
      return false
    }
    return true
  }

  const exoticTradeBody = () => {
    switch (form?.trade_type?.deal_type_group) {
      case DEAL_GROUP.DIGITAL_OPTION:
        return (
          <DigitalOptionTrade
            form={form}
            currencyData={currencyData}
            currencyInitial={currencyInitial}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
          />
        )

      case DEAL_GROUP.DIGITAL_KNOCK_IN_KNOCK_OUTS:
        return (
          <DigitalKnockInKnockOutTrade
            form={form}
            errors={errors}
            barrierDirectionData={barrierDirectionData}
            currencyData={currencyData}
            currencyInitial={currencyInitial}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
          />
        )

      case DEAL_GROUP.DOUBLE_NO_TOUCH_OPTION:
        return (
          <DoubleNoTouchOptionTrade
            form={form}
            errors={errors}
            barrierDirectionData={barrierDirectionData}
            currencyData={currencyData}
            currencyInitial={currencyInitial}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
          />
        )

      case DEAL_GROUP.DIGITAL_DOUBLES:
        return (
          <DigitalDoublesTrade
            form={form}
            errors={errors}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
            barrierDirectionData={barrierDirectionData}
            currencyData={currencyData}
            currencyInitial={currencyInitial}
          />
        )

      case DEAL_GROUP.MORE_DOUBLES:
        return (
          <MoreDoublesTrade
            errors={errors}
            form={form}
            barrierDirectionData={barrierDirectionData}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
          />
        )

      case DEAL_GROUP.TOUCH_OPTIONS:
        return (
          <TouchOptionsTrade
            errors={errors}
            form={form}
            barrierDirectionData={barrierDirectionData}
            currencyData={currencyData}
            currencyInitial={currencyInitial}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
          />
        )

      case DEAL_GROUP.ENHANCED_REVERSE_OPTIONS:
        return (
          <EnhancedReverseOptionTrade
            form={form}
            errors={errors}
            barrierDirectionData={barrierDirectionData}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
          />
        )

      case DEAL_GROUP.REMAINING_OPTIONS:
        return (
          <RemainingOptionsTrade
            form={form}
            errors={errors}
            barrierDirectionData={barrierDirectionData}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
          />
        )

      default:
        return <></>
    }
  }

  return {
    exoticTradeBody,
    submitForm,
    disabled,
    handelFormChange,
    handelDateChange,
    disabledField,
    disabledConversionCheckBox,
    handelBlurCurrencyPair,
    handelFocusCurrencyPair,
    getTradeTemplateGridRow,
    checkPrimeBrokerIsRBS,
    swapOption
  }
}

export default useTradeSetting
